import logger from '@eventbrite/client-logger';

const GOOGLE_PAY_SDK_URL = 'https://pay.google.com/gp/p/js/pay.js';

const scriptExists = (source: string) =>
    document.querySelector(`script[src="${source}"]`) !== null;

const loadScript = (
    onScriptLoad: () => void,
    onScriptLoadError: () => void,
) => {
    const source = GOOGLE_PAY_SDK_URL;

    if (scriptExists(source)) {
        onScriptLoad();
        return;
    }
    const node = document.createElement('script');

    node.src = source;
    node.onload = onScriptLoad;
    node.onerror = onScriptLoadError;
    node.async = true;

    if (process.env.NODE_ENV === 'development') {
        // This allows to easily identify the script and set its source manually
        // See doc: https://eventbrite.atlassian.net/wiki/spaces/CT2/pages/15415411400/Supported+Payment+Methods
        node.id = 'google-pay-script';
    }

    document.head.appendChild(node);
};

interface GooglePayScriptConfig {
    onScriptLoad: () => void;
    onScriptLoadError: () => void;
}

export const loadGooglePayScript = async (config: GooglePayScriptConfig) => {
    const { onScriptLoad, onScriptLoadError } = config;
    try {
        loadScript(onScriptLoad, onScriptLoadError);
    } catch (e) {
        onScriptLoadError();
        logger.error('Error loading Google Pay script: ', e);
    }
};
